import { ShellBridgeEvents } from 'app/shared/constants/constants';

// Kept as a named export because it is shared by the cart and confirmation flows.
// eslint-disable-next-line import/prefer-default-export
export const getShellPopToHomeResponseEvent = (isBlocked: boolean) => (
    isBlocked
        ? ShellBridgeEvents.MOBILE_BUTTONTAP_POPTOHOME_CANCEL
        : ShellBridgeEvents.MOBILE_BUTTONTAP_POPTOHOME_OK
);
